import React from "react";

import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Avatar from "@mui/material/Avatar";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";

import { useSelector } from "react-redux";
import { ComponentType } from "../../common/enum";

const CollectionDonationProductCardEventos = ({
  t,
  donationProduct,
  collectionProduct,
  setCollectionProduct,
  setProductError,
  componentType,
}) => {
  const {
    auth: {
      profile: { entity },
    },
  } = useSelector((state) => state);

  const collectionProductPayload = {
    donationProductId: donationProduct.idEventoRecolhido,
    productUnit: donationProduct.unit,
    createdBy: entity?.entityId,
    updatedBy: entity?.entityId,
  };

  const [quantity, setQuantity] = React.useState(0);
  const [error, setError] = React.useState("");
  const onAdd = React.useCallback(() => {
    if (Number(donationProduct.totalProductQuantity) <= quantity) {
      //setError("collectionSelectionProductError");
      //setProductError(true);
    } else {
     // setProductError(false);
      setQuantity((prev) => Number(prev) + 1);
      const value = collectionProduct.find(
        (item) => item.donationProductId === donationProduct.idEventoRecolhido
      );
      if (value !== undefined) {
        value["quantity"] = value.quantity + 1;
        setCollectionProduct(value);
      } else {
        collectionProductPayload["quantity"] = 1;
        setCollectionProduct(collectionProductPayload);
      }
      setError("");
    }
  }, [quantity, donationProduct]);

  const onSubtract = React.useCallback(() => {
    let value = collectionProduct.find(
      (item) => item.donationProductId === donationProduct.idEventoRecolhido
    );

    if (Number(donationProduct.totalProductQuantity) >= quantity) {
      //setError("");
      //setProductError(false);
      if (value !== undefined) {
        if (value.quantity >= 1) {
          value["quantity"] = value.quantity - 1;
          setCollectionProduct(value);
        } else {
          value.quantity = 0;
          setCollectionProduct(value);
        }
      }
    }
    setQuantity((prev) => (Number(prev) === 0 ? 0 : Number(prev) - 1));
  }, [quantity, donationProduct, collectionProduct]);

  const handleChange = React.useCallback(
    (e) => {
     // if (Number(donationProduct.availableQuantity) < Number(e.target.value)) {
       // setError("collectionSelectionProductError");
       // setProductError(true);
      //} else {
      //  setProductError(false);
      //  setError("");
        const value = collectionProduct.find(
          (item) => item.donationProductId === donationProduct.idEventoRecolhido
        );
        if (value !== undefined) {
          if (Number(e.target.value) === 0 || Number(e.target.value) < 0) {
            value.quantity = 0;
            setCollectionProduct(value);
          } else {
            value.quantity = Number(e.target.value);
            setCollectionProduct(value);
          }
        } else {
          if (Number(e.target.value) > 0) {
            collectionProductPayload["quantity"] = Number(e.target.value);
            setCollectionProduct(collectionProductPayload);
          }
        }
        setQuantity(e.target.value);
      //}
    },
    [collectionProduct, donationProduct, setCollectionProduct]
  );

  React.useEffect(() => {
    if (collectionProduct?.length === 0) {
      setQuantity(0);
    }
  }, [collectionProduct]);

  return (
    <Card variant="outlined">
      <CardContent>
        <Stack direction="row" spacing={2} alignItems="center">
          <Avatar
            alt="Product image"
            src={`/static/products/${donationProduct?.idProductCatalog}.jpg`}
            sx={{ width: 32, height: 32 }}
            variant="rounded"
          />
          <Typography variant="h6">
            {donationProduct.productName.length === 0
              ? donationProduct.productType
              : donationProduct.productName}
          </Typography>
        </Stack>
        {componentType !== ComponentType.AGENDA_PRODUCT && (
          <Typography
            variant="body1"
            color="text.secondary"
            mt={1}
            fontWeight={500}
          >
            {donationProduct.totalProductQuantity} {t(`${donationProduct.unit}`)}{" "}
            {/* {"Recolhidos(as) neste evento"} */}
          </Typography>
        )}
        {componentType === ComponentType.AGENDA_PRODUCT && (
          <Typography
            variant="body1"
            color="text.secondary"
            mt={1}
            fontWeight={500}
          >
            {donationProduct.productQuantity === undefined
              ? donationProduct.totalProductQuantity
              : donationProduct.productQuantity}{" "}
            {t(
              `${
                donationProduct.productUnit === undefined
                  ? donationProduct?.unit
                  : donationProduct?.productUnit
              }`
            )}{" "}
          </Typography>
        )}
        {componentType === ComponentType.DISTRIBUTOR_DONATION_PRODUCT && (
          <ButtonGroup variant="outlined" aria-label="outlined button group">
            <Button onClick={onSubtract}>-</Button>
            <input
              type="number"
              style={{
                width: "50px",
                textAlign: "center",
                fontSize: "14px",
                border: "0.5px solid #37B34A",
              }}
              value={quantity}
              onChange={handleChange}
              min={1}
              // readOnly
            />
            <Button onClick={onAdd}>+</Button>
          </ButtonGroup>
        )}
        {error.length > 0 && (
          <Typography variant="subtitle2" color="error">
            {t(`${error}`)}
          </Typography>
        )}
      </CardContent>
    </Card>
  );
};

export default CollectionDonationProductCardEventos;
